import { AdministratorDto } from ".";
import { IdentifiableDto } from "./identifiable.dto";
import { PermissionTypeDto } from "./lookup.dto";

export class PermissionDto extends IdentifiableDto {
    timestampCreated!: Date;
    permissionType: PermissionTypeDto;
    administrator: AdministratorDto;
    objectId: string;
}